export class ClearNextCategories {
  values: number[];

  constructor() {
    this.values = [];
  }
}
